import styled from 'styled-components'

const Button = styled.a`
  border: 1px solid white;
  color: white;
  font-size: 20px;
  text-decoration: none;
  padding: 20px;
  margin: 10px;
  background-color: rgba(0, 0, 0, .8);
`
export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js